import { render, staticRenderFns } from "./ridge-vineyards.vue?vue&type=template&id=77f48c40&scoped=true"
import script from "./ridge-vineyards.vue?vue&type=script&lang=js"
export * from "./ridge-vineyards.vue?vue&type=script&lang=js"
import style0 from "./ridge-vineyards.vue?vue&type=style&index=0&id=77f48c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f48c40",
  null
  
)

export default component.exports